export default "__VITE_ASSET__Dj$HGbQT__"